/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PairWatchSnapshotFromJSON, PairWatchSnapshotToJSON } from './PairWatchSnapshot';
/**
 * Check if a given object implements the SnapshotResponse interface.
 */
export function instanceOfSnapshotResponse(value) {
    if (!('fetchedAt' in value) || value['fetchedAt'] === undefined)
        return false;
    if (!('snapshots' in value) || value['snapshots'] === undefined)
        return false;
    return true;
}
export function SnapshotResponseFromJSON(json) {
    return SnapshotResponseFromJSONTyped(json, false);
}
export function SnapshotResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fetchedAt': json['fetched_at'],
        'snapshots': (json['snapshots'].map(PairWatchSnapshotFromJSON)),
    };
}
export function SnapshotResponseToJSON(json) {
    return SnapshotResponseToJSONTyped(json, false);
}
export function SnapshotResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'fetched_at': value['fetchedAt'],
        'snapshots': (value['snapshots'].map(PairWatchSnapshotToJSON)),
    };
}
